"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateQuote = void 0;
const _ = require("lodash");
const updateQuote = async (supabase, quote) => {
    const obj = _.cloneDeep(quote);
    // if quote is type of QuoteExtended, remove the following properties
    if ("accepted_by_user" in obj) {
        delete obj.accepted_by_user;
    }
    if ("created_by_user" in obj) {
        delete obj.created_by_user;
    }
    if ("email_log" in obj) {
        delete obj.email_log;
    }
    const { data, error } = await supabase.from("quotes").upsert(obj).single();
    if (error) {
        console.log("error", error);
        throw new Error(error.message);
    }
    return data;
};
exports.updateQuote = updateQuote;
